/*
 * The name should match with a key of a mark in a rating.
 */

import { BookStructure, RatingType } from '../../../../../shared/enums';

const ratingData = {
  [RatingType.OUTLINE]: {
    [BookStructure.NARRATIVE_NONFICTION]: [
      {
        name: 'contentCoverage',
        label: 'writerRatingModal.outline.bookStructure1.criteria1.title',
        message: 'writerRatingModal.outline.bookStructure1.criteria1.message',
        description: 'writerRatingModal.outline.bookStructure1.criteria1.description',
      },
      {
        name: 'structureOrganization',
        label: 'writerRatingModal.outline.bookStructure1.criteria2.title',
        message: 'writerRatingModal.outline.bookStructure1.criteria2.message',
        description: 'writerRatingModal.outline.bookStructure1.criteria2.description',
      },
      {
        name: 'informationAccuracy',
        label: 'writerRatingModal.outline.bookStructure1.criteria3.title',
        message: 'writerRatingModal.outline.bookStructure1.criteria3.message',
        description: 'writerRatingModal.outline.bookStructure1.criteria3.description',
      },
    ],
    [BookStructure.TOPIC_BASED]: [
      {
        name: 'contentCoverage',
        label: 'writerRatingModal.outline.bookStructure2.criteria1.title',
        message: 'writerRatingModal.outline.bookStructure2.criteria1.message',
        description: 'writerRatingModal.outline.bookStructure2.criteria1.description',
      },
      {
        name: 'structureOrganization',
        label: 'writerRatingModal.outline.bookStructure2.criteria2.title',
        message: 'writerRatingModal.outline.bookStructure2.criteria2.message',
        description: 'writerRatingModal.outline.bookStructure2.criteria2.description',
      },
      {
        name: 'informationAccuracy',
        label: 'writerRatingModal.outline.bookStructure2.criteria3.title',
        message: 'writerRatingModal.outline.bookStructure2.criteria3.message',
        description: 'writerRatingModal.outline.bookStructure2.criteria3.description',
      },
    ],
  },
  [RatingType.SAMPLE]: {
    [BookStructure.NARRATIVE_NONFICTION]: [
      {
        name: 'alignmentWithOutline',
        label: 'writerRatingModal.sample.bookStructure1.criteria1.title',
        message: 'writerRatingModal.sample.bookStructure1.criteria1.message',
        description: 'writerRatingModal.sample.bookStructure1.criteria1.description',
      },
      {
        name: 'neutralToneAssessment',
        label: 'writerRatingModal.sample.bookStructure1.criteria2.title',
        message: 'writerRatingModal.sample.bookStructure1.criteria2.message',
        description: 'writerRatingModal.sample.bookStructure1.criteria2.description',
      },
    ],
    [BookStructure.TOPIC_BASED]: [
      {
        name: 'alignmentWithOutline',
        label: 'writerRatingModal.sample.bookStructure1.criteria1.title',
        message: 'writerRatingModal.sample.bookStructure1.criteria1.message',
        description: 'writerRatingModal.sample.bookStructure1.criteria1.description',
      },
      {
        name: 'neutralToneAssessment',
        label: 'writerRatingModal.sample.bookStructure1.criteria2.title',
        message: 'writerRatingModal.sample.bookStructure1.criteria2.message',
        description: 'writerRatingModal.sample.bookStructure1.criteria2.description',
      },
    ],
  },
  [RatingType.DRAFT]: {
    [BookStructure.NARRATIVE_NONFICTION]: [
      {
        name: 'alignmentWithOutline',
        label: 'writerRatingModal.draft.bookStructure1.criteria1.title',
        message: 'writerRatingModal.draft.bookStructure1.criteria1.message',
        description: 'writerRatingModal.draft.bookStructure1.criteria1.description',
      },
      {
        name: 'neutralToneAssessment',
        label: 'writerRatingModal.draft.bookStructure1.criteria2.title',
        message: 'writerRatingModal.draft.bookStructure1.criteria2.message',
        description: 'writerRatingModal.draft.bookStructure1.criteria2.description',
      },
      {
        name: 'factualAccuracy',
        label: 'writerRatingModal.draft.bookStructure1.criteria3.title',
        message: 'writerRatingModal.draft.bookStructure1.criteria3.message',
        description: 'writerRatingModal.draft.bookStructure1.criteria3.description',
      },
      {
        name: 'overallExperience',
        label: 'writerRatingModal.draft.bookStructure1.criteria4.title',
        message: 'writerRatingModal.draft.bookStructure1.criteria4.message',
        description: 'writerRatingModal.draft.bookStructure1.criteria4.description',
      },
    ],
    [BookStructure.TOPIC_BASED]: [
      {
        name: 'alignmentWithOutline',
        label: 'writerRatingModal.draft.bookStructure2.criteria1.title',
        message: 'writerRatingModal.draft.bookStructure2.criteria1.message',
        description: 'writerRatingModal.draft.bookStructure2.criteria1.description',
      },
      {
        name: 'neutralToneAssessment',
        label: 'writerRatingModal.draft.bookStructure2.criteria2.title',
        message: 'writerRatingModal.draft.bookStructure2.criteria2.message',
        description: 'writerRatingModal.draft.bookStructure2.criteria2.description',
      },
      {
        name: 'factualAccuracy',
        label: 'writerRatingModal.draft.bookStructure2.criteria3.title',
        message: 'writerRatingModal.draft.bookStructure2.criteria3.message',
        description: 'writerRatingModal.draft.bookStructure2.criteria3.description',
      },
      {
        name: 'overallExperience',
        label: 'writerRatingModal.draft.bookStructure2.criteria4.title',
        message: 'writerRatingModal.draft.bookStructure2.criteria4.message',
        description: 'writerRatingModal.draft.bookStructure2.criteria4.description',
      },
    ],
  },
};

export default (bookStructure, ratingType) => ratingData[ratingType][bookStructure];
